import { MONTHS } from './consts';

export const getShortMonth = (date: Date, language: string) =>
  MONTHS[language]?.SHORT_MONTHS?.[date.getMonth()];
